import { stringify } from 'query-string'
import {
  API_CALLCENTER_BASE_URL,
  API_TIMEOUT,
} from 'shared/constants/defaultENV'

import { Api } from './ApiGlobals'

const CallApi = new Api({
  baseURL: API_CALLCENTER_BASE_URL,
  timeout: API_TIMEOUT,
})

CallApi.instance.defaults.paramsSerializer = function (params) {
  return stringify(params)
}

export default CallApi
